import { IconProps } from '../icon';

export function LogoGreenkubWhiteIcon(props: IconProps) {
  return (
    <svg
      height="230.215"
      width="739.83"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="#fff">
        <path d="m213.026 111.816.028 24.701.003 3.393-3.166 1.218-57.876 22.276-1.774.683-1.772-.683-57.892-22.274-3.164-1.216v-28.112c-26.397 7.557-43.57 19.741-43.57 33.463 0 22.877 47.71 41.487 106.353 41.487 58.642 0 106.352-18.61 106.352-41.487 0-13.712-17.152-25.891-43.522-33.449zm-4.983-42.119h-.001l.026 22.259z" />
        <path d="m208.118 136.523-.05-44.568-.025-22.259-57.685-22.291-58.009 22.292v66.828l57.892 22.274zm-58.603 12.856-46.143-17.753a2.021 2.021 0 0 1 -1.294-1.886v-53.264a2.02 2.02 0 0 1 1.295-1.884l46.236-17.768a2.017 2.017 0 0 1 1.451.002l45.955 17.758h.001l.021.008c.02.007.034.022.053.03.125.052.248.109.361.188.023.016.04.039.063.055.051.038.093.082.14.124a1.893 1.893 0 0 1 .362.431c.067.108.12.222.166.34.021.055.046.105.062.162.051.178.084.361.084.551l.06 53.264a2.016 2.016 0 0 1 -2.019 2.021c-.244 0-.49-.044-.725-.134l-43.386-16.701v32.57a2.02 2.02 0 0 1 -2.743 1.886z" />
        <path d="m150.33 60.873-44.214 16.99v50.492l42.105 16.199v-50.325c0-.835.514-1.584 1.293-1.884l41.188-15.871z" />
        <path d="m152.259 110.598 42.089 16.2-.053-47.381-42.036 16.198zm169.907-24.51c-4.798-4.72-11.484-7.079-17.698-7.079-16.125 0-24.384 11.798-24.305 24.541 0 12.978 8.259 24.148 24.305 24.148 5.899 0 12.035-2.045 16.754-6.371v-15.417h-19.192v-3.697h23.203v20.608c-5.741 5.742-12.585 8.889-20.765 8.889-18.72 0-28.395-13.058-28.395-28.081-.079-17.227 11.641-28.474 28.395-28.474a28.66 28.66 0 0 1 20.137 8.259zm57.735 44.914h-5.585l-19.035-20.844h-15.024v20.844h-4.247v-55.061h24.227c11.955 0 18.012 8.574 18.09 17.147.08 8.967-5.82 16.833-17.856 16.833zm-39.644-24.856h19.507c9.596 0 13.843-5.427 13.923-13.136.078-6.449-4.327-13.135-13.45-13.135h-19.98zm50.891-4.798h32.249v3.854h-32.249v21.71h34.767v4.09h-38.936v-55.061h37.993v4.012h-33.824zm48.298 0h32.249v3.854h-32.249v21.71h34.766v4.09h-38.935v-55.061h37.992v4.012h-33.823zm47.666-25.407 37.048 45.543v-45.543h4.169v55.061h-1.653l-37.124-45.464v45.464h-4.248v-55.061zm96.514.315-24.463 26.351 26.507 27.766v.629h-12.819l-23.048-24.384v24.384h-10.383v-55.06h10.383v23.283l20.923-23.283h12.9zm53.095-.235v31.541c0 16.282-9.99 24.62-23.834 24.62-13.214 0-24.462-8.023-24.462-24.62v-31.541h10.304v31.541c0 9.911 5.663 15.182 14.237 15.182 8.573 0 13.45-5.742 13.45-15.182v-31.541zm54.903 15.888c0 4.247-2.045 8.338-7.159 10.618 6.452 1.967 8.812 8.81 8.812 12.271 0 12.271-9.203 16.204-20.608 16.204h-26.114v-55.061h26.114c10.853 0 18.955 4.877 18.955 15.968m-34.846 6.135h15.89c6.529 0 8.652-2.753 8.652-5.9 0-2.516-2.045-6.764-8.652-6.764h-15.89zm0 23.283h15.89c4.247 0 10.304-1.416 10.304-6.607 0-4.956-6.057-7.551-10.304-7.551h-15.89z" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(275.897 163.247)"
        >
          E
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(293.24 163.247)"
        >
          T
        </text>
        <text transform="translate(309.121 163.247)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(320.27 163.247)"
        >
          L
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(334.73 163.247)"
        >
          E
        </text>
        <text transform="translate(352.072 163.247)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(363.222 163.247)"
        >
          J
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(376.222 163.247)"
        >
          A
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(393.563 163.247)"
        >
          R
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(412.34 163.247)"
        >
          D
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(431.116 163.247)"
        >
          I
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(438.34 163.247)"
        >
          N
        </text>
        <text transform="translate(457.116 163.247)" />
        <g fontFamily="'Helvetica'" fontSize="26">
          <text transform="translate(468.267 163.247)">D</text>
          <text transform="translate(487.043 163.247)">E</text>
          <text transform="translate(504.385 163.247)">V</text>
          <text transform="translate(521.727 163.247)">I</text>
          <text transform="translate(528.95 163.247)">E</text>
          <text transform="translate(546.292 163.247)">N</text>
          <text transform="translate(565.068 163.247)">T</text>
        </g>
        <text transform="translate(580.95 163.247)" />
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(592.1 163.247)"
        >
          M
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(613.758 163.247)"
        >
          A
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(631.1 163.247)"
        >
          I
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(638.323 163.247)"
        >
          S
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(655.665 163.247)"
        >
          O
        </text>
        <text
          fontFamily="'Helvetica'"
          fontSize="26"
          transform="translate(675.889 163.247)"
        >
          N
        </text>
      </g>
    </svg>
  );
}

export default LogoGreenkubWhiteIcon;
